export const CHECK_MOBILE = 'CHECK_MOBILE' // 检测是否为手机，以宽度768px
export const CHECK_BOTTOM = 'CHECK_BOTTOM' // 检测是否已到底部

// 用户部分
export const LOGIN = 'LOGIN' // 登陆
export const USER_INFO = 'USER_INFO' // 用户信息
export const SET_BASE_INFO = 'SET_BASE_INFO' // 第一表单信息

// TGO 学员状态
export const APPLY_STATUS_INFO = 'APPLY_STATUS_INFO' // 申请状态信息

export const SET_GLOBAL_LAYERS = 'SET_GLOBAL_LAYERS'
